import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { EntityService } from '../../../services/entity.service';
import { BaseModel } from '../../../models/base.model';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-master-list',
  templateUrl: './master-list.component.html',
  styleUrls: ['./master-list.component.scss']
})
export class MasterListComponent implements OnChanges {
  @Input() selectedEntity: BaseModel;
  @Output() entitySelected = new EventEmitter<any>();
  @Input() refreshTrigger: boolean;

  entityFields: any[] = [];
  entities: any[] = [];
  paginatedEntities: any[] = [];
  currentPage = 1;
  pageSize = 5;
  totalPages = 1;

  constructor(private entityService: EntityService, private logger: LoggerService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedEntity'] && this.selectedEntity) {
      this.loadEntities();  // Cargar entidades si se selecciona una nueva entidad
    }

    // Detectar si hubo un cambio en refreshTrigger
    if (changes['refreshTrigger'] && !changes['refreshTrigger'].firstChange) {
      this.loadEntities();  // Recargar entidades cuando se haya guardado/creado una nueva entidad
    }
  }

  loadEntities() {
    this.logger.info("MasterListComponent.loadEntities");
    this.entityFields = this.entityService.getEntityFields(this.selectedEntity.getName());
    this.entityService.getAll(this.selectedEntity.getApiName())
      .subscribe(response => {
        this.entities = response;
        this.logger.serializeMessage(this.entities, "MasterListComponent.loadEntities: ");
        this.updatePagination();
      }, error => {
        this.logger.error('Error al cargar los registros:', error);
      });
  }

  updatePagination() {
    this.totalPages = Math.ceil(this.entities.length / this.pageSize);
    this.paginatedEntities = this.entities.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  changePageSize(event: Event) {
    const target = event.target as HTMLSelectElement;
    const pageSize = Number(target.value);
    this.pageSize = pageSize;
    this.currentPage = 1;
    this.updatePagination();
  }

  // Función para seleccionar una entidad y emitirla al componente padre
  selectEntity(entityData: any) {
    this.entitySelected.emit(entityData);
    entityData = {};
  }

   // Función para verificar si el campo es un objeto y devolver una propiedad específica
  getFieldValue(field: any, entity: any): any {
    const value = entity[field.name];
    // LoggerService.serializeMessage(field);
    if (Array.isArray(value)) {
      return value.map((item: any) => {
        if (item && typeof item === 'object') {
          return item.name || item.description || item.id || 'N/A';
        } else {
          return 'N/A'; // Si no es un objeto, devolvemos 'N/A' para ese elemento
        }
      }).join(' :: ');  // Concatenamos los valores separados por salto de línea
    }
    else if (field.type === 'password') {
      return '********';
    }
    else {
      // Verificamos si el valor existe y es un objeto
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        // Intentamos acceder a las propiedades 'name', 'description' u otras propiedades comunes
        return value.name || value.description || value.id || 'N/A';  // Puedes ajustar esta línea con más propiedades si es necesario
      }
      // Si no es un objeto o no tiene propiedades comunes, devolvemos el valor directamente
      return value !== undefined && value !== null ? value : 'N/A';
    }
  }
}
